import React, { ChangeEvent } from "react";
import { RouteComponentProps } from "react-router";

import withTitle from "../withTitle";
import { V2 } from "../../Api";
import DelayInput from "../DelayInput";
import ViewToolbar from "../ViewToolbar";
import HasRight from "../HasRight";
import { Link } from "react-router-dom";

interface IInsuranceCompaniesViewState {
    isLoading: boolean | string;
    searchValue: string,

    companies: any[];

    [name: string]: any;
}

class InsuranceCompaniesView extends React.Component<RouteComponentProps<any>, IInsuranceCompaniesViewState> {
    constructor(props: Readonly<RouteComponentProps<any>>) {
        super(props);

        const state: IInsuranceCompaniesViewState = {
            isLoading: true,

            companies: [],

            searchValue: "",
        };

        this.state = state;

        this.handleElementChanged = this.handleElementChanged.bind(this);
        this.goCompany = this.goCompany.bind(this);
    }

    public async componentDidMount() {
        this.loadData();
    }

    public render() {
        return (
            <div className="viewer-root">
                <ViewToolbar>
                    <HasRight right="acct:ins:create">
                        <Link to="/accounting/insurance-companies/new" className="icon-plus" />
                    </HasRight>
                </ViewToolbar>
                <div className="filter-control-box">
                    <DelayInput type="text" className="fill-space" placeholder="Search..." timeout={500} name="searchValue" value={this.state.searchValue} onChangeDelayed={this.handleElementChanged} />
                </div>
                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Parent</th>
                            <th className="col-smallest">Private?</th>
                        </tr>
                    </thead>
                    <thead className="table-vertical-head-small">
                        <tr>
                            <th>Insurance Companies</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.isLoading === true
                                ? <tr><td colSpan={4}><div className="spinner spinner-center lds-dual-ring" /></td></tr>
                                : typeof this.state.isLoading === "string"
                                    ? <tr><td colSpan={4}><span className="error-text">{this.state.isLoading}</span></td></tr>
                                    : this.state.companies.map(a => (
                                        <tr key={a.id} className="clickable" onClick={() => this.goCompany(a.id)}>
                                            <td className="inline" data-caption="Name: ">{a.name}</td>
                                            <td className="inline" data-caption="Parent: ">{a.parent ? a.parent.name : "-"}</td>
                                            <td className="inline" data-caption="Is Private?: ">{a.isPrivate ? <i className="icon-check" title="Yes, is private" /> : null}</td>
                                        </tr>
                                    ))}
                    </tbody>
                </table>
            </div>
        );
    }

    private async loadData() {
        try {
            this.setState({
                isLoading: true
            });

            const parameters = [];
            if (this.state.searchValue) {
                parameters.push(`q=${this.state.searchValue}`);
            }

            const data = await V2.get<any[]>(`accounting/insurance-companies?${parameters.join("&")}`);

            this.setState({
                isLoading: false,

                companies: data,
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || e || "Could not load CPT list"
            });
        }
    }

    private handleElementChanged(e: ChangeEvent<HTMLInputElement>) {
        const name = e.currentTarget.name;
        const value = e.currentTarget.value;

        this.setState({
            [name]: value
        }, () => this.loadData());
    }

    private goCompany(id: string) {
        this.props.history.push(`/accounting/insurance-companies/${id}`);
    }
}

export default withTitle("Insurance Companies", InsuranceCompaniesView);